export const VERTICAL_THEMES = {
  general: {
    id: 'general',
    label: 'Comercio general',
    shortLabel: 'MI FACTURADOR',
    tagline: 'Administración web',
    colors: {
      primary: '#7B1FA2',
      primaryDark: '#6A1B9A',
      secondary: '#FF9800',
      background: '#EDE7F6',
      accent: '#A56CC1',
    },
  },
  ferreteria: {
    id: 'ferreteria',
    label: 'Ferretería',
    shortLabel: 'MI FACTURADOR',
    tagline: 'Especializado en Ferreterías',
    colors: {
      primary: '#B45309',
      primaryDark: '#92400E',
      secondary: '#EA580C',
      background: '#F5F5F4',
      accent: '#F59E0B',
    },
  },
  farmacia: {
    id: 'farmacia',
    label: 'Farmacia',
    shortLabel: 'MI FACTURADOR',
    tagline: 'Especializado en Farmacias',
    colors: {
      primary: '#0F766E',
      primaryDark: '#115E59',
      secondary: '#0EA5E9',
      background: '#F0FDFA',
      accent: '#2DD4BF',
    },
  },
};

export const DEFAULT_VERTICAL_ID = 'general';

export function normalizeBusinessType(value) {
  const v = String(value || '').toLowerCase().trim();
  return VERTICAL_THEMES[v] ? v : DEFAULT_VERTICAL_ID;
}

export function getVerticalTheme(businessType) {
  return VERTICAL_THEMES[normalizeBusinessType(businessType)];
}
